import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService {

    public show: boolean = true;
    public loader: boolean = false;

    constructor() {
    }

}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/modules/spinner/spinner.service.ts